import complianceApi from "api/services/compliance";
import { DeliveryZoneDecisionResponse } from "custom-types/Compliance";
import { Location } from "custom-types/Location";
import logger from "lib/logger";

const fallbackResponse = {
  result: false,
  violations: [
    {
      message: "Unable to validate user's address for delivery.",
      type: "string",
    },
  ],
};

const getDeliveryZoneFromAddress = async (
  dispensaryId: number,
  customerAddress: Location
): Promise<DeliveryZoneDecisionResponse> => {
  try {
    const { data } = await complianceApi.post(
      `/v2/dispensary/${dispensaryId}/delivery/decision/address`,
      {
        customerAddress,
      }
    );

    if (!data) {
      return fallbackResponse;
    }

    return data;
  } catch (err) {
    logger.error(err as Error);
    return fallbackResponse;
  }
};

export default getDeliveryZoneFromAddress;
